var React = require('react');

function ArrowLeft2Icon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M31.106 15H3.278l8.325-8.293c.391-.391.391-1.024 0-1.414-.391-.391-1.024-.391-1.414 0l-9.9 9.899c-.385.385-.385 1.029 0 1.414l9.9 9.9c.391.391 1.024.391 1.414 0 .391-.391.391-1.024 0-1.414L3.278 17h27.828c.552 0 1-.448 1-1s-.448-1-1-1z","clipRule":"evenodd"}));
}

ArrowLeft2Icon.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = ArrowLeft2Icon;

ArrowLeft2Icon.default = ArrowLeft2Icon;
